<template>
    <v-container 
        class="state-template"
        fluid>
        <v-row
            align="start"
            align-content="center">
            <v-col
                v-if="$vuetify.breakpoint.smAndUp"
                class="state-template__map-container"
                align-self="center"
                cols="3"
                md="6">
                <state-map
                    v-if="selectedState"
                    :current-state="selectedState">
                </state-map>
            </v-col>
            <v-col
                class="py-0">
                <v-row
                    class="state-template__info"
                    no-gutters>
                    <v-col
                        cols="12">
                        <div
                            class="state-template__title primary--text font-weight-bold my-2">
                            {{ stateName }}
                        </div>
                        <div
                            v-if="$vuetify.breakpoint.mdAndUp"
                            class="state-template__state-description mb-3">
                            {{ stateDescription }}
                        </div>
                        <stat-list
                            color="primary"
                            :stats="stats">
                        </stat-list>
                        <marketing-stories
                            v-if="$vuetify.breakpoint.smAndUp"
                            color="primary"
                            :stories="stories">
                        </marketing-stories>
                    </v-col>
                </v-row>
            </v-col>
            <v-col
                v-if="$vuetify.breakpoint.xsOnly"
                class="state-template__map-container"
                align-self="center"
                cols="3"
                md="6">
                <state-map
                    v-if="selectedState"
                    :current-state="selectedState">
                </state-map>
            </v-col>
            <v-col
                class="py-0"
                v-if="$vuetify.breakpoint.xsOnly">
                <marketing-stories
                    color="primary"
                    :stories="stories">
                </marketing-stories>
            </v-col>
            <call-to-action v-if="$vuetify.breakpoint.xsOnly"></call-to-action>
        </v-row>
        <v-container
            v-if="$vuetify.breakpoint.xsOnly">
            <narrative-disclaimer
                :has-marketing-stats="false">
            </narrative-disclaimer>
        </v-container>
    </v-container>
</template>

<script>
    import marketingStats from "../../constants/marketingStats";

    import MarketingStories from "../marketing/MarketingStories";
    import NarrativeDisclaimer from "../narrative/NarrativeDisclaimer";
    import StateMap from "./StateMap";
    import StatList from "./StatList";
    import CallToAction from "../header/CallToAction";

    export default {
        name: "state-template",
        components: {
            CallToAction,
            MarketingStories,
            NarrativeDisclaimer,
            StateMap,
            StatList,
        },
        data() {
            return {
                marketingStats: marketingStats
            }
        },
        props: {
            narrativeStats: Object,
            stateStats: Object,
        },
        computed: {
            selectedState(){
                return this.$route.params.state.toUpperCase();
            },
            stateDescription(){
                let raceCount = this.stateStats[this.selectedState].races.total.count;
                if(raceCount > 0){
                    return `DSPolitical worked on ${this.stateStats[this.selectedState].races.total.count} ${raceCount === 1 ? 'race' : 'races'} in ${this.stateName} in 2024.`;
                } else {
                    return `${this.stateName} state was part of a nationwide campaign in 2024.`
                }
            },
            stateName(){
                return this.stateStats[this.selectedState].name;
            },
            stats(){
                return Object.values(this.stateStats[this.selectedState].races).filter(stat => {
                    return stat.count > 0 && stat.name != 'Total';
                });
            },
            stories() {
                return marketingStats.filter(story => story.narrative === this.selectedState);
            },
        },
    }
</script>

<style lang="scss">
    @import "../../styles/_variables.scss";
    .state-template{
        &.container{
            align-items: start;
        }
        &__state-description{
            font-size: 16px;
            line-height: 18px;
            max-width: 500px;
        }
        a{
            text-decoration: none;
            text-decoration-color: none;
            text-decoration-color: none;
        }
        &__map-container{
            display: flex;
            justify-content: center;
            min-height: 100%;
            min-width: 100%;
            max-height: 500px;
            @media screen and (min-width: $md) {
                min-height: 400px;
                min-width: 400px;
            }
        }
        @media screen and (min-width: $lg) {
            &__title {
                font-size: 24px;
            }
            &__info {
                max-width: 600px !important;
            }
        }
        @media screen and (min-width: $xl) {
            &__title {
                font-size: 30px;
            }
            &__info {
                width: 600px !important;
            }
        }
    }
</style>